import React from 'react';
import packageJson from '../../package.json';

export default function Version() {
  const version = packageJson.version;
  console.log('package:' , packageJson.name)
  return (
    <div className="version">
      <div>v:{version}</div>
    </div>
  );
}